import _ from 'underscore';

export default class UserManageMembers {
  constructor($scope, UserContactService) {
    $scope.tabs = [
      {
        title: 'Pending Registrations',
        count: 0
      },
      {
        title: 'Pending Accounts',
        count: 0
      },
      {
        title: 'Pending Invitations',
        count: 0
      },
      {
        title: 'Activated Accounts',
        count: 0
      },
      {
        title: 'Deactivated Accounts',
        count: 0
      },
      {
        title: 'No Accounts',
        count: 0
      }
    ];

    $scope.set_selected_tab = function(index) {
      $scope.selected_tab = index;
    };

    $scope.invitation_status = function(invitation) {
      if (invitation)
        return invitation.status == 0 ? 'Pending' : 'Accepted';
      else
        return '';
    };

    $scope.cancel_invitation = function(contact) {
      UserContactService.delete_invitation(contact.invitation.id).then(function(data) {
        if (data.success) {
          $scope.pending_invitations.splice(window.pending_invitations.indexOf(contact), 1);
          $scope.tabs[2].count = window.pending_invitations.length;
          alert('Invitation is now cancelled!');
        } else {
          alert('Error while cancelling invitation!');
        }
      });
    };

    $scope.set_account_status = function(account, status, tab_index) {
      UserContactService.update_account_status(account.account_id, status).then(function(data) {
        if (data.success) {
          if (tab_index == 1) {
            $scope.pending_accounts.splice(window.pending_accounts.indexOf(account), 1);
            $scope.tabs[1].count = window.pending_accounts.length;
          } else if (tab_index == 3) {
            $scope.activated_accounts.splice(window.activated_accounts.indexOf(account), 1);
            $scope.tabs[3].count = window.activated_accounts.length;
          } else if (tab_index == 4) {
            $scope.deactivated_accounts.splice(window.deactivated_accounts.indexOf(account), 1);
            $scope.tabs[4].count = window.deactivated_accounts.length;
          }
          alert('Account is now ' + status + '!');
        } else {
          alert('Error while changing account status!');
        }
      });
    };

    $scope.init = function() {
      $scope.selected_tab = 0;
      $scope._ = _;
      $scope.pending_registrations = window.pending_registrations;
      $scope.pending_accounts = window.pending_accounts;
      $scope.pending_invitations = window.pending_invitations;
      $scope.activated_accounts = window.activated_accounts;
      $scope.deactivated_accounts = window.deactivated_accounts;
      $scope.tabs[0].count = window.pending_registrations.length;
      $scope.tabs[1].count = window.pending_accounts.length;
      $scope.tabs[2].count = window.pending_invitations.length;
      $scope.tabs[3].count = window.activated_accounts.length;
      $scope.tabs[4].count = window.deactivated_accounts.length;
    };

    $scope.init();
  }
}

UserManageMembers.$inject = ['$scope', 'UserContactService'];



// WEBPACK FOOTER //
// ./front/js/admin/controllers/user-manage-members.ctrl.js